<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M6.09 8.871a2.434 2.434 0 1 0 4.867 0 2.434 2.434 0 0 0-4.867 0ZM4.352 16.172a4.172 4.172 0 1 1 8.343 0H4.352ZM14.086 9.219h4.172M14.086 12h5.562"
  /><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M21.04 3.656H2.96a1.39 1.39 0 0 0-1.39 1.39v13.907a1.39 1.39 0 0 0 1.39 1.39h2.782a1.39 1.39 0 1 1 2.781 0h6.954a1.39 1.39 0 1 1 2.78 0h2.782a1.39 1.39 0 0 0 1.39-1.39V5.047a1.39 1.39 0 0 0-1.39-1.39Z"
  /></svg>
</template>
